import React from 'react';
import {Button, Flex} from "antd";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";

const StepNavigation = ({
                            currentStep,
                            totalSteps,
                            onPrev,
                            onNext,
                            onSave,
                            onSendToCheck,
                            isLoading
                        }) => {
    const isFirstStep = currentStep === 0;
    const isLastStep = currentStep === totalSteps - 1;

    return (
        <Flex
            justify={isFirstStep ? "flex-end" : "space-between"}
            align={"center"}
            style={{width: '100%'}}
            gap={"small"}
        >
            {!isFirstStep && (
                <Button
                    style={{margin: '0 8px'}}
                    onClick={onPrev}
                >
                    <IntlMessage id={'back'}/>
                </Button>
            )}

            <Button
                type="primary"
                onClick={onSave}
                loading={isLoading}
            >
                <IntlMessage id={"save"}/>
            </Button>

            {isLastStep && (
                <Button
                    type="primary"
                    onClick={onSendToCheck}
                >
                    <IntlMessage id={'sendToCheck'}/>
                </Button>
            )}

            {!isLastStep && (
                <Flex gap={"small"}>
                    <Button
                        type="primary"
                        onClick={onNext}
                        loading={isLoading}
                    >
                        <IntlMessage id={'next'}/>
                    </Button>
                </Flex>
            )}
        </Flex>
    );
};

export default StepNavigation;
